import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const YamlEditorAndroid: React.FC = () => (
  <SEOLandingPage
    title="YAML Editor for Android — Edit Config Files on Your Phone | Cosmovex"
    metaDescription="Edit YAML files on Android with syntax validation, structure view, and offline support. Perfect for GitHub Actions, docker-compose, and k8s configs."
    ogTitle="YAML Editor for Android — YAML Viewer And Editor"
    h1="YAML Editor for Android"
    intro="Edit YAML files on your Android phone with proper syntax validation and structure highlighting. YAMLVEdit is built for developers who manage GitHub Actions workflows, docker-compose files, and Kubernetes configs from their phone."
    paragraphs={[
      "YAML is everywhere in modern development — GitHub Actions, docker-compose, Kubernetes manifests, Ansible playbooks, CI/CD pipelines. When you need to tweak a workflow file or fix a broken config while away from your desk, YAMLVEdit gives you a proper editor on Android with syntax validation that catches indentation errors before they break your build.",
      "YAML's indentation-sensitive syntax makes it notoriously easy to introduce errors. YAMLVEdit validates the structure in real time, highlighting any lines where the indentation or syntax is wrong. Error messages explain what went wrong — whether it's a duplicate key, a tab character where spaces are required, or a missing colon after a key.",
      "The structure view parses the YAML and shows you the hierarchy as an expandable tree. You can navigate to any key in a deeply nested config without scrolling through hundreds of lines. This is especially useful for Kubernetes manifests and Helm values files that can run to several hundred lines with nested specs.",
      "YAMLVEdit works entirely offline. There's no upload, no server processing, no cloud sync. Open a file from your Downloads folder, from Google Drive, or from any file manager — edit it, validate it, and save it back. It's the YAML editor Android developers have needed when debugging configs on the go.",
    ]}
    features={[
      "Edit YAML files with syntax highlighting and validation",
      "Real-time indentation and structure error detection",
      "Expandable tree view for nested YAML structures",
      "Support for GitHub Actions, docker-compose, and k8s configs",
      "Detect and report duplicate keys",
      "Tab-to-spaces conversion to prevent YAML indent errors",
      "Search within YAML files with key and value matching",
      "Open files from file manager, Google Drive, or cloud storage",
      "Works fully offline — no internet connection needed",
      "Copy, share, or export edited YAML files",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.yamlvedit"
    icon="/images/yamlvedit.png"
    appName="YAMLVEdit"
    accentColor="#A8720E"
    canonicalPath="/yaml-editor-android"
  />
);

export default YamlEditorAndroid;
